module.exports = new __parcel__URL__("the-division-bell.560a294a.jpg").toString();